import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import * as moment from "moment";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import * as CanvasJS from "./canvasjs.stock.min";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { DialogOverviewExampleDialogComponent } from "../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { CommonModule } from "@angular/common";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenu, MatMenuModule } from "@angular/material/menu";
import { AssetHealthBoxComponent } from "../../asset-health-box/asset-health-box.component";
import { GaugeChartComponent } from "../../client/device-detail-nxt/gauge-chart-component/gauge-chart-component.component";
import { AssetDetailsBoxComponent } from "../../asset-details-box/asset-details-box.component";
import { LineChartComponent } from "../../client/line-chart/line-chart.component";
import { SpinnerComponent } from "../../spinner/spinner.component";
import { CylinderModalComponent } from "../cylinder-modal/cylinder-modal.component";
import { MatTooltip, MatTooltipModule } from "@angular/material/tooltip";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { CylinderStackChartComponent } from "../../../app/components/cylinder-stack-chart/cylinder-stack-chart.component";
import { SyncChartsModalComponent } from "../sync-charts-modal/sync-charts-modal.component";

@Component({
  selector: "app-cylinder-dashboard",
  templateUrl: "./cyclinder-dashboard.component.html",
  styleUrls: ["./cyclinder-dashboard.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    NgbNavModule,
    MatMenu,
    MatMenuModule,
    AssetHealthBoxComponent,
    GaugeChartComponent,
    AssetDetailsBoxComponent,
    LineChartComponent,
    SpinnerComponent,
    CylinderModalComponent,
    MatTooltipModule,
    MatTooltip,
    MatButton,
    MatButtonModule,
    CylinderStackChartComponent,
    SyncChartsModalComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CyclinderDashboardComponent implements OnInit {
  public emeterData = BaseUrlConstantsService.energyMeterApi;
  public monitoringSensorAPI = BaseUrlConstantsService.MONITORING_SENSOR_API;
  public assetsUrlEdit = BaseUrlConstantsService.ASSETS_DATA_EDIT;
  public bucketsensordata = BaseUrlConstantsService.Bucktet_Sensor_Data;
  public alert24hrurl = BaseUrlConstantsService.BASE_ALERT_SYSTEM_URL;
  public assetsListUrl = BaseUrlConstantsService.ASSETS_LIST;
  public cylinderBaseUrl = BaseUrlConstantsService.CYLINDER_BASE_URL;
  public cylinderTrendsGraph =
    BaseUrlConstantsService.CYLINDER_TREND_CHARTS_API;

  // USERS
  clientid: string | number = "";
  role = "";
  lastFileProcessedTime = ""; //last file for rotating assets joined to cylinder
  last_message: string = ""; // last file for flow,pressure
  cylinder_status: boolean = false; // cylinder status

  //gauge var
  public dataGadge: any;
  Itemsymbol: any;
  public canvasWidth = 160;
  accelerationData: any;
  public monitoringmaxaccobj: any;
  public monitoringTempratueResults: any;

  public ultrasoundValue: any = 0.0;
  public monitoringAudibleValue: any;

  //dials
  public monitoringMeterShowVelocity: any;
  public meterShownResult: any = [];

  public velocityG: any;
  public velocityY: any;
  public velocityR: any;

  public magneticX: any = 0;
  public magneticY: any = 0;
  public magneticZ: any = 0;

  public _orientationX: any;
  public _orientationY: any;
  public _orientationZ: any;

  public MonitoringMagacoustic: {
    needleValue: any;
    centralLabel: any;
    outerNeedle: boolean;
    canvasWidth: number;
    name: any;
    key: any;
    bottomLabel: string;
    hasneedle: any;
    options: {
      hasNeedle: any;
      needleColor: string;
      needleUpdateSpeed: string;
      arcColors: any;
      arcLabels: any[];
      arcDelimiters: any;
      rangeLabel: any;
      needleStartValue: number;
    };
  };

  public rtdData: any = [];

  public flowDataObj;
  public pressureDataObj;

  //loaders
  public machineVibrationLoading: boolean = true;
  public tempgaugeLoader: boolean = true;
  public acousticgaugeLoader: boolean = true;
  public audibleLoader: boolean = true;
  public flowLoader: boolean = true;
  public pressureLoader: boolean = true;

  //booleans
  gaugeShow = false;
  gaugedisplay: boolean;
  displaytempgauge: boolean = false;

  //----
  cccount: number = 0;
  valll: any;
  Optionsss: any;
  public assetType: string = "MOTOR";
  public rateOfChange: any = [];
  public trendsFilter: any = "hour";

  public company_name: string;
  public today: string;
  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "All Cylinders",
    },
    {
      page_ref: "#",
      page_title: "Monitoring Analysis",
    },
  ];

  //ACCELERATION DATA
  accLineMovingAvg;
  accMovingCount;
  accLoading = true;
  accelerationColors = [];
  accelerationLineData = [];
  accLineUnit = "";
  accLineChartOptions = "";

  //TEMPERATURE DATA
  tempLineMovingAvg;
  tempMovingCount;
  tempLoading = true;
  tempColors = [];
  tempLineData = [];
  tempLineUnit = "";
  tempLineChartOptions = "";

  //Velocity DATA
  velLineMovingAvg;
  velMovingCount;
  velLoading = true;
  velColors = [];
  velLineData = [];
  velLineUnit = "";
  velLineChartOptions = "";

  //Velocity DATA
  audibleLineMovingAvg;
  audibleMovingCount;
  audibleLoading = true;
  audibleColors = [];
  audibleLineData = [];
  audibleLineUnit = "";
  audibleLineChartOptions = "";

  //Ultrasound DATA
  usoundLineMovingAvg;
  usoundMovingCount;
  usoundLoading = true;
  usoundColors = [];
  usoundLineData = [];
  usoundLineUnit = "";
  usoundLineChartOptions = "";

  //Flow DATA
  flowLineMovingAvg;
  flowMovingCount;
  flowLoading = true;
  flowColors = [];
  flowLineData = [];
  flowLineUnit = "";
  flowLineChartOptions = "";

  //Pressure DATA
  pressureLineMovingAvg;
  pressureMovingCount;
  pressureLoading = true;
  pressureColors = [];
  pressureLineData = [];
  pressureLineUnit = "";
  pressureLineChartOptions = "";

  // 24 health bar
  public stackvelocitychartLoader: boolean = false;
  public stackData = [];
  ballBearingOn = false;
  public lastHours = [8, 13, 24];

  // ALERTS
  noalertmessage: any;
  errordata: any[];
  currentdate: any;

  // SETTINGS
  assetDataObject: any;
  public kurt_freq: any;
  public kurt_threshold: any;
  public kurt_anomaly_counter: any;

  // TABS STATUS
  tabsObj = {
    tabName: null,
    tab1: true,
    tab2: false,
    tab3: false,
    tab4: false,
    tab5: true, // default true as we are in tab5
    tab6: false, // no idea what is tab 6 for ??
    tab7: false,
  };
  client_id: any;
  subsystem_id: any;
  asset_id: any;
  device_id: any;
  mac_address: any;
  site_name: any;
  application_name: any;
  cylinder_name: any;

  //Modal Data
  flowPressModalData: any = {};
  showFlowPressModal = false;
  showStackedModal = false;
  showTrendGraphs = false;
  constructor(
    private service: BackendApiService,
    private router: Router,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) {
    const {
      tab1,
      tab2,
      tab3,
      tab4,
      tab5,
      tab6,
      tab7,
      tabName,
      client_id,
      subsystem_id,
      asset_id,
      device_id,
      mac_address,
      site_name,
      application_name,
      cylinder_name,
    } = this.activatedRoute.snapshot.queryParams;
    this.tabsObj = { tab1, tab2, tab3, tab4, tab5, tab6, tab7, tabName };
    this.client_id = client_id;
    this.subsystem_id = subsystem_id;
    this.asset_id = asset_id;
    this.device_id = device_id;
    this.mac_address = mac_address;
    this.site_name = site_name;
    this.application_name = application_name;
    this.cylinder_name = cylinder_name;
    console.log(this.activatedRoute.snapshot.queryParams);
    console.log(this.site_name, this.application_name);
  }

  async ngOnInit(): Promise<void> {
    this.utcTime();
    this.company_name = localStorage.getItem("company_name");
    this.monitoringGaugeData();
    this.getFlowGaugeDataV2();
    this.getPressureGaugeDataV2();
    this.getUltrasoundData();
    // this.stackchartvelocity();
    // this.getalertsummmary();
    this.fetchAssetSettingData();
  }
  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  public async monitoringGaugeData(
    machineVibReload = true,
    tempReload = true,
    acousticReload = true
  ) {
    this.machineVibrationLoading = machineVibReload;
    this.tempgaugeLoader = tempReload;
    this.acousticgaugeLoader = acousticReload;
    this.cccount = 0;
    let sensorRes = await this.service
      .getDataWithQuery(
        this.monitoringSensorAPI +
          parseInt(this.asset_id) +
          "/" +
          parseInt(this.device_id) +
          "?userId=" +
          this.client_id
      )
      .then((sRes) => {
        return JSON.parse(JSON.stringify(sRes)).data;
      });
    if (sensorRes.body.sensor.length > 0) {
      this.machineVibrationLoading = false;
      let response = sensorRes.body;
      this.meterShownResult = [];
      this.monitoringMeterShowVelocity = [];
      this.dataGadge = response.sensor.filter(
        (item, i, arr) => arr.findIndex((t) => t.key === item.key) === i
      );
      let ultrasoundResponse = response.ultrasoundData;
      let bottomLab = "N/A";
      if (this.dataGadge.length !== 0) {
        let tempArr = [];
        for (let mCount = 0; mCount < this.dataGadge.length; mCount++) {
          if (
            JSON.parse(this.dataGadge[mCount].value) === 0 &&
            this.dataGadge[mCount].needle === false
          ) {
            bottomLab = "N/A";
          } else {
            bottomLab =
              JSON.parse(this.dataGadge[mCount].value) <= 0
                ? "N/A"
                : this.dataGadge[mCount].symbol === "C"
                ? JSON.parse(this.dataGadge[mCount].value) +
                  " °" +
                  this.dataGadge[mCount].icon
                : JSON.parse(this.dataGadge[mCount].value) +
                  " " +
                  this.dataGadge[mCount].icon;
          }
          this.Itemsymbol = this.dataGadge[mCount].symbol;
          let needleValueRes;
          if (this.dataGadge[mCount].symbol === "m/sec²") {
            needleValueRes =
              (JSON.parse(this.dataGadge[mCount].value) * 100) /
              parseFloat(this.dataGadge[mCount].rangelabel[1]);
          } else if (this.dataGadge[mCount].symbol === "mm/sec") {
            needleValueRes =JSON.parse(this.dataGadge[mCount].value)
          } else if (this.dataGadge[mCount].symbol === "deg") {
            needleValueRes = JSON.parse(this.dataGadge[mCount].value);
          } else {
            needleValueRes = JSON.parse(this.dataGadge[mCount].value);
          }
          let centerLab =
            JSON.parse(this.dataGadge[mCount].value) < 0
              ? "N/A"
              : JSON.parse(this.dataGadge[mCount].value);
          let arc_colors =
            this.dataGadge[mCount].needle === true
              ? this.dataGadge[mCount].arcColors
              : ["transparent", "transparent", "transparent"];
          let range_label =
            this.dataGadge[mCount].needle === true
              ? this.dataGadge[mCount].rangelabel
              : [];
          let arc_Delimiters =
            this.dataGadge[mCount].needle === true
              ? this.dataGadge[mCount].arcDelimiters
              : [];
          let value =
            JSON.parse(this.dataGadge[mCount].value) < 0
              ? "N/A"
              : JSON.parse(this.dataGadge[mCount].value);

          this.accelerationData = {
            needleValue: needleValueRes,
            centralLabel: centerLab,
            outerNeedle: false,
            canvasWidth: 150,
            name: this.dataGadge[mCount].name,
            key: this.dataGadge[mCount].key,
            bottomLabel: bottomLab,
            hasneedle: this.dataGadge[mCount].needle,
            options: {
              hasNeedle: this.dataGadge[mCount].needle,
              needleColor: "black",
              needleUpdateSpeed: "",
              arcColors: arc_colors,
              arcLabels: [],
              arcDelimiters: this.dataGadge[mCount].arcDelimiters,
              rangeLabel: range_label,
              needleStartValue: 0,
            },
          };
          if (
            this.accelerationData.key === "x_velocity" ||
            this.accelerationData.key === "y_velocity" ||
            this.accelerationData.key === "z_velocity"
          ) {
            if (
              arc_Delimiters[0] < 100 &&
              arc_Delimiters[0] > 0 &&
              arc_Delimiters[1] > 0 &&
              arc_Delimiters[0] < arc_Delimiters[1] &&
              arc_Delimiters[1] < 100
            ) {
              let max = range_label[1] != null ? range_label[1] : 0;
              this.accelerationData.options.arcLabels[0] =
                sensorRes.body.rangeLabels.green;
              this.accelerationData.options.arcLabels[1] =
                sensorRes.body.rangeLabels.yellow;
              this.velocityG = sensorRes.body.rangeLabels.green;
              this.velocityY = sensorRes.body.rangeLabels.yellow;
              this.velocityR = max;
              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";

              if (
                this.accelerationData.centralLabel <=
                this.accelerationData.options.arcLabels[0]
              ) {
                // accelerationData.options.centralLabel=
                this.accelerationData.options.needleColor = "#72FF13";
              } else if (
                this.accelerationData.centralLabel >
                  this.accelerationData.options.arcLabels[0] &&
                this.accelerationData.centralLabel <=
                  this.accelerationData.options.arcLabels[1]
              ) {
                this.accelerationData.options.needleColor = "#FAA700";
              } else {
                this.accelerationData.options.needleColor = "#ff2a1b";
              }
              this.monitoringMeterShowVelocity.push(this.accelerationData);
              this.machineVibrationLoading = false;
            } else {
              arc_Delimiters[0] = 20;
              arc_Delimiters[1] = 70;
              let max = range_label[1] != null ? range_label[1] : 0;
              this.accelerationData.options.arcLabels[0] =
                sensorRes.body.rangeLabels.green;
              this.accelerationData.options.arcLabels[1] =
                sensorRes.body.rangeLabels.yellow;
              this.velocityG = sensorRes.body.rangeLabels.green;
              this.velocityY = sensorRes.body.rangeLabels.yellow;
              this.velocityR = max;
              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";
              // console.log("THIS VELOCITY G"+this.velocityG)
              if (
                this.accelerationData.centralLabel <=
                this.accelerationData.options.arcLabels[0]
              ) {
                // accelerationData.options.centralLabel=
                this.accelerationData.options.needleColor = "#72FF13";
              } else if (
                this.accelerationData.centralLabel >
                  this.accelerationData.options.arcLabels[0] &&
                this.accelerationData.centralLabel <=
                  this.accelerationData.options.arcLabels[1]
              ) {
                this.accelerationData.options.needleColor = "#FAA700";
              } else {
                this.accelerationData.options.needleColor = "#ff2a1b";
              }

              this.monitoringMeterShowVelocity.push(this.accelerationData);
              this.machineVibrationLoading = false;
            }

            if (this.monitoringMeterShowVelocity.length > 0) {
              this.machineVibrationLoading = false;
            }
          }

          this.changeOrder(
            ["z_velocity", "y_velocity", "x_velocity"],
            this.monitoringMeterShowVelocity
          );
          if (this.dataGadge[mCount].symbol === "C") {
            this.accelerationData.needleValue > 150
              ? (this.accelerationData.bottomLabel = "N/A")
              : this.accelerationData.needleValue;
          }
          if (this.accelerationData.key === "RMS_Accel_1_X_Axis") {
            if (
              arc_Delimiters[0] < 100 &&
              arc_Delimiters[0] > 0 &&
              arc_Delimiters[1] > 0 &&
              arc_Delimiters[0] < arc_Delimiters[1] &&
              arc_Delimiters[1] < 100
            ) {
              let max = range_label[1] != null ? range_label[1] : 0;
              let a = arc_Delimiters[0] / 100;
              let b = arc_Delimiters[1] / 100;
              let k = a * max;
              let l = b * max;
              let r = k.toFixed(1);
              let s = l.toFixed(1);
              this.accelerationData.options.arcLabels[0] = r;
              this.accelerationData.options.arcLabels[1] = s;
              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";
              this.meterShownResult.splice(0, 0, this.accelerationData);
            } else {
              arc_Delimiters[0] = 20;
              arc_Delimiters[1] = 70;
              let max = range_label[1] != null ? range_label[1] : 0;
              let a = arc_Delimiters[0] / 100;
              let b = arc_Delimiters[1] / 100;
              let k = a * max;
              let l = b * max;
              let r = k.toFixed(1);
              let s = l.toFixed(1);
              this.accelerationData.options.arcLabels[0] = r;
              this.accelerationData.options.arcLabels[1] = s;
              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";
              this.meterShownResult.splice(0, 0, this.accelerationData);
            }
          }
          if (this.accelerationData.key === "RMS_Accel_1_Y_Axis") {
            let max = range_label[1];
            let a = arc_Delimiters[0] / 100;
            let b = arc_Delimiters[1] / 100;
            let k = a * max;
            let l = b * max;
            let r = k.toFixed(1);
            let s = l.toFixed(1);
            this.accelerationData.options.arcLabels[0] = r;
            this.accelerationData.options.arcLabels[1] = s;
            this.accelerationData.options.arcColors[0] = "#72FF13";
            this.accelerationData.options.arcColors[1] = "#FAA700";
            this.accelerationData.options.arcColors[2] = "#ff2a1b";
            this.meterShownResult.splice(1, 0, this.accelerationData);
          }
          if (this.accelerationData.key === "RMS_Accel_1_Z_Axis") {
            let max = range_label[1];
            let a = arc_Delimiters[0] / 100;
            let b = arc_Delimiters[1] / 100;
            let k = a * max;
            let l = b * max;
            let r = k.toFixed(1);
            let s = l.toFixed(1);
            this.accelerationData.options.arcLabels[0] = r;
            this.accelerationData.options.arcLabels[1] = s;
            this.accelerationData.options.arcColors[0] = "#72FF13";
            this.accelerationData.options.arcColors[1] = "#FAA700";
            this.accelerationData.options.arcColors[2] = "#ff2a1b";
            this.meterShownResult.splice(2, 0, this.accelerationData);
          }

          //code to find out max of aacclaration
          if (this.meterShownResult.length == 3) {
            let temparr = [];

            this.meterShownResult.forEach((i) => {
              temparr.push(Math.sqrt(2) * parseFloat(i.centralLabel));
            });
            temparr.sort(function (a, b) {
              return a - b;
            });
            // accelerationData.needleValue=  (temparr[temparr.length - 1]* 100) /
            //   parseFloat(accelerationData.options.rangeLabel[1]);
            if (this.cccount < 1) {
              this.valll = temparr[temparr.length - 1];
              this.monitoringmaxaccobj = this.accelerationData;
              let needleRes =
                (this.valll * 100) /
                parseFloat(this.monitoringmaxaccobj.options.rangeLabel[1]);
              this.monitoringmaxaccobj.needleValue = needleRes;
              this.monitoringmaxaccobj.name = "Peak Acceleration";
              if (this.valll < this.monitoringmaxaccobj.options.arcLabels[0]) {
                this.monitoringmaxaccobj.options.needleColor = "#72FF13";
              } else if (
                this.valll > this.monitoringmaxaccobj.options.arcLabels[0] &&
                this.valll < this.monitoringmaxaccobj.options.arcLabels[1]
              ) {
                this.monitoringmaxaccobj.options.needleColor = "#FAA700";
              } else {
                this.monitoringmaxaccobj.options.needleColor = "#ff2a1b";
              }
              this.Optionsss = this.monitoringmaxaccobj.options;
              this.monitoringmaxaccobj.centralLabel = this.valll.toFixed(2);
              this.monitoringmaxaccobj.bottomLabel =
                this.monitoringmaxaccobj.centralLabel.toString() + " m/sec²";
              if (this.monitoringmaxaccobj != undefined) {
                this.gaugedisplay = true;
              }

              this.cccount++;
            }
          }

          if (
            this.accelerationData.key !== "RMS_Accel_1_X_Axis" &&
            this.accelerationData.key !== "RMS_Accel_1_Y_Axis" &&
            this.accelerationData.key !== "RMS_Accel_1_Z_Axis" &&
            this.accelerationData.key !== "Rate of change of orientation" &&
            this.accelerationData.key !== "Pitch" &&
            this.accelerationData.key !== "Roll" &&
            this.accelerationData.key !== "Yaw" &&
            this.accelerationData.key !== "x_mag" &&
            this.accelerationData.key !== "y_mag" &&
            this.accelerationData.key !== "z_mag" &&
            this.accelerationData.key !== "ultrasound" &&
            this.accelerationData.key !== "audible" &&
            this.accelerationData.key !== "x_velocity" &&
            this.accelerationData.key !== "y_velocity" &&
            this.accelerationData.key !== "z_velocity" &&
            this.accelerationData.key !== "Bearing_Temperature" &&
            this.accelerationData.key !== "Winding_Temperature" &&
            this.accelerationData.key !== "Ambient_Temperature" &&
            this.accelerationData.key !== "Rate of change of useful life left"
          ) {
            //code to set label by Deepak
          }
          this.changeOrder(
            ["RMS_Accel_1_Z_Axis", "RMS_Accel_1_Y_Axis", "RMS_Accel_1_X_Axis"],
            this.meterShownResult
          );
          if (
            this.accelerationData.key === "Bearing_Temperature" ||
            this.accelerationData.key === "Winding_Temperature" ||
            this.accelerationData.key === "Ambient_Temperature"
          ) {
            if (
              this.assetType === "MOTOR" ||
              this.assetType === "FAN_BLOWER" ||
              this.assetType === "PUMP" ||
              this.assetType === "COMPRESSOR" ||
              this.assetType === "JOURNAL_BEARING"
            ) {
              range_label[0] = "0";
              range_label[1] = "100";

              let max = range_label[1];
              this.accelerationData.options.hasNeedle = true;

              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";

              let a = this.accelerationData.options.arcDelimiters[0] / 100;
              let b = this.accelerationData.options.arcDelimiters[1] / 100;
              let k = a * max;
              let l = b * max;
              let r = k.toFixed(0);
              let s = l.toFixed(0);
              this.accelerationData.options.arcLabels[0] = r;
              this.accelerationData.options.arcLabels[1] = s;
              if (this.accelerationData.bottomLabel == "N/A") {
                this.accelerationData.needleValue = 0;
                this.accelerationData.canvasWidth = 0;
              }

              if (
                this.accelerationData.needleValue <
                this.accelerationData.options.arcLabels[0]
              ) {
                this.accelerationData.options.needleColor = "#72FF13";
              } else if (
                this.accelerationData.needleValue >
                  this.accelerationData.options.arcLabels[0] &&
                this.accelerationData.needleValue <
                  this.accelerationData.options.arcLabels[1]
              ) {
                this.accelerationData.options.needleColor = "#FAA700";
              } else {
                this.accelerationData.options.needleColor = "#ff2a1b";
              }
              tempArr.push(this.accelerationData);

              if (tempArr.length >= 3) {
                this.monitoringTempratueResults =
                  this.imposeRtdOrdering(tempArr);
                this.monitoringTempratueResults =
                  this.monitoringTempratueResults.map((temp) => {
                    if (temp.key == "Bearing_Temperature") {
                      //DE BEARING
                      temp.name = "Surface End";
                    } else if (temp.key == "Winding_Temperature") {
                      // NA
                      temp.name = "Cylinder End";
                    }
                    return temp;
                  });
                this.monitoringTempratueResults =
                  this.monitoringTempratueResults.slice(0, 2);
                if (this.monitoringTempratueResults) {
                  this.displaytempgauge = true;
                  this.tempgaugeLoader = false;
                }
                this.monitoringTempratueResults =
                  this.monitoringTempratueResults.slice(0, 1);
                this.monitoringTempratueResults.push({
                  ...this.monitoringTempratueResults[0],
                });
                this.monitoringTempratueResults[1].name = "Surface End";
                this.monitoringTempratueResults[1].needleValue = 0.0;
                this.monitoringTempratueResults[1].bottomLabel = "N/A"; // hard coded for now till no value arrives
                this.monitoringTempratueResults[1].centralLabel = "N/A"; // hard coded for now till no value arrives
                this.monitoringTempratueResults[0].name = "Cylinder End"; // hard coded for now till no value arrives
                console.log(this.monitoringTempratueResults);
              }
            } else {
              range_label[0] = "0";
              range_label[1] = "100";
              let max = range_label[1];
              this.accelerationData.options.hasNeedle = true;

              this.accelerationData.options.arcColors[0] = "#72FF13";
              this.accelerationData.options.arcColors[1] = "#FAA700";
              this.accelerationData.options.arcColors[2] = "#ff2a1b";

              let a = this.accelerationData.options.arcDelimiters[0] / 100;
              let b = this.accelerationData.options.arcDelimiters[1] / 100;
              let k = a * max;
              let l = b * max;
              let r = k.toFixed(0);
              let s = l.toFixed(0);
              this.accelerationData.options.arcLabels[0] = r;
              this.accelerationData.options.arcLabels[1] = s;
              if (this.accelerationData.bottomLabel == "N/A") {
                this.accelerationData.needleValue = 0;
                this.accelerationData.canvasWidth = 0;
              }

              if (
                this.accelerationData.needleValue <
                this.accelerationData.options.arcLabels[0]
              ) {
                this.accelerationData.options.needleColor = "#72FF13";
              } else if (
                this.accelerationData.needleValue >
                  this.accelerationData.options.arcLabels[0] &&
                this.accelerationData.needleValue <
                  this.accelerationData.options.arcLabels[1]
              ) {
                this.accelerationData.options.needleColor = "#FAA700";
              } else {
                this.accelerationData.options.needleColor = "#ff2a1b";
              }
              tempArr.push(this.accelerationData);
              if (tempArr.length >= 3) {
                this.monitoringTempratueResults =
                  this.imposeRtdOrdering(tempArr);
                if (this.monitoringTempratueResults) {
                  this.displaytempgauge = true;
                  this.tempgaugeLoader = false;
                }
              }
            }
          }
          if (this.accelerationData.key === "x_mag") {
            this.magneticX = this.accelerationData.needleValue.toFixed(2);
          }
          if (this.accelerationData.key === "y_mag") {
            this.magneticY = this.accelerationData.needleValue.toFixed(2);
          }
          if (this.accelerationData.key === "z_mag") {
            this.magneticZ = this.accelerationData.needleValue.toFixed(2);
          }

          if (this.accelerationData.key === "ultrasound") {
            let max = range_label[1];
            let a = arc_Delimiters[0] / 100;
            let b = arc_Delimiters[1] / 100;
            let k = a * max;
            let l = b * max;
            let r = k.toFixed(1);
            let s = l.toFixed(1);
            this.accelerationData.options.arcLabels[0] = r;
            this.accelerationData.options.arcLabels[1] = s;
            this.accelerationData.options.arcColors[0] = "#72FF13";
            this.accelerationData.options.arcColors[1] = "#FAA700";
            this.accelerationData.options.arcColors[2] = "#ff2a1b";
            // this.accelerationData.bottomLabel = "0.0dB";
            this.accelerationData.needleValue = 0;
            this.MonitoringMagacoustic = this.accelerationData;
            this.MonitoringMagacoustic.options.arcLabels[0] = (+this
              .MonitoringMagacoustic.options.arcLabels[0]).toFixed(0);
            this.MonitoringMagacoustic.options.arcLabels[1] = (+this
              .MonitoringMagacoustic.options.arcLabels[1]).toFixed(0);
            let predictedNumber = this.accelerationData.centralLabel;
            this.MonitoringMagacoustic.bottomLabel =
              predictedNumber.toFixed(1) + "dB";
            this.MonitoringMagacoustic.needleValue =
              (parseFloat(predictedNumber.toFixed(2)) * 100) /
              this.MonitoringMagacoustic.options.rangeLabel[1];
            this.ultrasoundValue = parseFloat(predictedNumber.toFixed(2));
            if (this.MonitoringMagacoustic) {
              this.acousticgaugeLoader = false;
            }
            if (
              this.ultrasoundValue >= 0.0 &&
              this.ultrasoundValue <
                this.MonitoringMagacoustic.options.arcLabels[0]
            ) {
              this.MonitoringMagacoustic.options.needleColor = "#72FF13";
            } else if (
              this.ultrasoundValue >
                this.MonitoringMagacoustic.options.arcLabels[0] &&
              this.ultrasoundValue <
                this.MonitoringMagacoustic.options.arcLabels[1]
            ) {
              this.MonitoringMagacoustic.options.needleColor = "#FAA700";
            } else {
              this.MonitoringMagacoustic.options.needleColor = "#ff2a1b";
            }
            this.MonitoringMagacoustic.name = "Ultrasound";
            console.log(this.MonitoringMagacoustic);
          }
          if (this.accelerationData.key === "audible") {
            this.monitoringAudibleValue =
              this.accelerationData.needleValue.toFixed(1);
            this.audibleLoader = false;
          }
          if (
            this.accelerationData.key === "Rate of change of useful life left"
          ) {
            this.rateOfChange.push(this.accelerationData);
          }
          if (this.accelerationData.key === "Pitch") {
            this._orientationX = this.accelerationData.needleValue.toFixed(3);
          }
          if (this.accelerationData.key === "Roll") {
            this._orientationY = this.accelerationData.needleValue.toFixed(3);
          }
          if (this.accelerationData.key === "Yaw") {
            this._orientationZ = this.accelerationData.needleValue.toFixed(3);
          }
        }
      }
    }
    this.machineVibrationLoading = false;
    // this.stackchartvelocity();
  }
  changeOrder(orderBy, list) {
    return list.sort((x, y) => orderBy.indexOf(x.key) - orderBy.indexOf(y.key));
  }
  imposeRtdOrdering(dataSet: any) {
    const rtd1 = this.rtdData[0]?.rtd_one;
    const rtd2 = this.rtdData[0]?.rtd_two;
    const rtd3 = this.rtdData[0]?.rtd_three;
    if (rtd1 === "MS") {
      dataSet[0].name = "Machine Skin";
    } else if (rtd1 === "DE") {
      dataSet[0].name = "DE Bearing";
    } else if (rtd1 === "NDE") {
      dataSet[0].name = "NDE Bearing";
    }
    if (rtd2 === "MS") {
      dataSet[1].name = "Machine Skin";
    } else if (rtd2 === "DE") {
      dataSet[1].name = "DE Bearing";
    } else if (rtd2 === "NDE") {
      dataSet[1].name = "NDE Bearing";
    } else {
      dataSet[1].name = "NA";
    }
    if (rtd3 === "MS") {
      dataSet[2].name = "Machine Skinn";
    } else if (rtd3 === "DE") {
      dataSet[2].name = "DE Bearing";
    } else if (rtd3 === "NDE") {
      dataSet[2].name = "NDE Bearing";
    } else {
      dataSet[2].name = "NA";
    }
    return dataSet;
  }

  async getFlowGaugeDataV2() {
    this.flowLoader = true;
    let sensorRes: any = await this.service
      // .getDataWithQuery(
      //   `http://localhost:7778/cylinder/gauge/flow/${this.asset_id}/${this.subsystem_id}/${this.client_id}`
      // )
      .getDataWithQuery(
        `${this.cylinderBaseUrl}/cylinder/gauge/flow/${this.asset_id}/${this.subsystem_id}/${this.client_id}`
      )
      .then((sRes) => {
        this.flowLoader = false;
        return JSON.parse(JSON.stringify(sRes)).data;
      });
    const flowData = sensorRes.body.gaugeData;
    this.last_message = sensorRes.body.last_message;
    this.flowDataObj = flowData;
    this.flowPressModalData = {
      ...this.flowPressModalData,
      flow: sensorRes.body.modalData,
      asset_id: this.asset_id,
      subsystem_id: this.subsystem_id,
      client_id: this.client_id,
    };
    let localTime = new ConvertDatetimePipe().convertDateTime(new Date());
    // this.cylinder_status=this.getAssetStatus(this.last_message,localTime)
  }

  async getPressureGaugeDataV2() {
    this.pressureLoader = true;
    let sensorRes = await this.service
      .getDataWithQuery(
        // `http://localhost:7778/cylinder/gauge/pressure/${this.asset_id}/${this.subsystem_id}/${this.client_id}`
        `${this.cylinderBaseUrl}/cylinder/gauge/pressure/${this.asset_id}/${this.subsystem_id}/${this.client_id}`
      )
      .then((sRes) => {
        this.pressureLoader = false;
        return JSON.parse(JSON.stringify(sRes)).data;
      });
    const flowData = sensorRes.body.gaugeData;
    console.log(flowData);
    this.pressureDataObj = flowData;
    this.flowPressModalData = {
      ...this.flowPressModalData,
      pressure: sensorRes.body.modalData,
    };
  }

  public getTempData() {
    this.tempLoading = true;
    //Enerty Meter:: Line Graph :: Current.
    this.service
      .getDataWithQuery(
        // `http://localhost:7778/cylinder/trends/trends-temp/${this.client_id}/${this.asset_id}/${this.device_id}/day/1,2,3/${this.subsystem_id}`
        `${this.cylinderBaseUrl}/cylinder/trends/trends-temp/${this.client_id}/${this.asset_id}/${this.device_id}/${this.trendsFilter}/1,2/${this.subsystem_id}`
      )
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.tempLineData = [];
          this.tempColors = [];

          this.tempLineChartOptions = response.name;
          this.tempLineUnit = response.symbol;

          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;
              barData.forEach((data) => {
                data.dataPoints.forEach((point) => {
                  point.label = new Date(point.label + "Z").toLocaleString(
                    "en-IN",
                    {
                      timeZone: "Asia/Kolkata",
                    }
                  );
                });
              });
              this.tempLineData.push(barData);
            }

            if (response.rangeLabels.length != 0) {
              this.tempColors.push(response.rangeLabels);
            }

            if (this.tempColors.length >= 1 || this.tempLineData.length >= 1) {
              setTimeout(() => {
                this.tempLoading = false;
              }, 1000);
            }
          }

          if (response.movingAvg != undefined) {
            if (response.movingAvg.length != 0) {
              this.tempLineMovingAvg = response.movingAvg;
              this.tempMovingCount = response.movingCount;
            }
          }
        }
      })
      .catch((err) => {
        this.tempLineData = [];
        this.tempColors = [];
      })
      .finally(() => {
        this.tempLoading = false;
      });
  }
  public getMeterAccData() {
    this.accLoading = true;
    //Enerty Meter:: Line Graph :: Current.
    this.service
      .getDataWithQuery(
        `${this.cylinderBaseUrl}/cylinder/trends/trends-acc/${this.client_id}/${this.asset_id}/${this.device_id}/${this.trendsFilter}/6,7,8/${this.subsystem_id}`
        // `http://localhost:7778/cylinder/trends/trends-acc/${this.client_id}/${this.asset_id}/${this.device_id}/day/6,7,8/${this.subsystem_id}`
      )
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.accelerationLineData = [];
          this.accelerationColors = [];

          this.accLineChartOptions = response.name.toString();
          this.accLineUnit = response.symbol;

          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;
              this.lastFileProcessedTime =
                barData[0].dataPoints[barData[0].dataPoints.length - 1].label;
              let lastFileTime: Date = new Date(this.lastFileProcessedTime);
              let now: Date = new Date();
              this.cylinder_status =
                (now.getTime() - lastFileTime.getTime()) / 60000 <= 30;
              // let testDateUtc = moment.utc(this.lastFileProcessedTime);
              // let localDate = testDateUtc.local();
              // let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
              //   localDate
              // );

              // this.lastFileProcessedTime = timeUpdatedAt;

              // this.accelerationLineData.push(barData);
            }

            if (response.rangeLabels.length != 0) {
              // this.accelerationColors.push(response.rangeLabels);
            }

            if (
              this.accelerationColors.length >= 1 ||
              this.accelerationLineData.length >= 1
            ) {
              // setTimeout(() => {
              //   this.accLoading = false;
              // }, 1000);
            }
          }

          if (response.movingAvg != undefined) {
            if (response.movingAvg.length != 0) {
              // this.accLineMovingAvg = response.movingAvg;
              // this.accMovingCount = response.movingCount;
            }
          }
        }
      })
      .finally(() => {
        // this.accLoading = false;
      });
  }
  public getUltrasoundData() {
    this.usoundLoading = true;
    //Enerty Meter:: Line Graph :: Current.
    this.service
      .getDataWithQuery(
        // `http://localhost:7778/cylinder/trends/trends-usound/${this.client_id}/${this.asset_id}/${this.device_id}/${this.trendsFilter}/35/${this.subsystem_id}`
        `${this.cylinderBaseUrl}/cylinder/trends/trends-usound/${this.client_id}/${this.asset_id}/${this.device_id}/${this.trendsFilter}/35/${this.subsystem_id}`
      )
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.usoundLineData = [];
          this.usoundColors = [];

          this.usoundLineChartOptions = response.name.toString();
          this.usoundLineUnit = response.symbol;

          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;
              this.lastFileProcessedTime =
                barData[0].dataPoints[barData[0].dataPoints.length - 1].label;
              let lastFileTime: Date = new Date(this.lastFileProcessedTime);
              let now: Date = new Date();

              this.cylinder_status =
                (now.getTime() - lastFileTime.getTime()) / 60000 <= 30;
              this.usoundLineData.push(barData);
            }

            if (response.rangeLabels.length != 0) {
              this.usoundColors.push(response.rangeLabels);
            }

            if (
              this.accelerationColors.length >= 1 ||
              this.usoundLineData.length >= 1
            ) {
              setTimeout(() => {
                this.usoundLoading = false;
              }, 1000);
            }
          }

          if (response.movingAvg != undefined) {
            if (response.movingAvg.length != 0) {
              this.usoundLineMovingAvg = response.movingAvg;
              this.usoundMovingCount = response.movingCount;
            }
          }
        }
      })
      .catch((err) => {
        this.usoundLineData = [];
        this.usoundColors = [];
      })
      .finally(() => {
        this.usoundLoading = false;
      });
  }

  public getVelocityData() {
    this.velLoading = true;
    //Enerty Meter:: Line Graph :: Current.
    this.service
      .getDataWithQuery(
        // `http://localhost:7778/cylinder/trends/trends-vel/${this.client_id}/${this.asset_id}/${this.device_id}/hour/29,30,31/${this.subsystem_id}`
        `${this.cylinderBaseUrl}/cylinder/trends/trends-vel/${this.client_id}/${this.asset_id}/${this.device_id}/${this.trendsFilter}/29,30,31/${this.subsystem_id}`
      )
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.velLineData = [];
          this.velColors = [];

          this.velLineChartOptions = response.name;
          this.velLineUnit = response.symbol;

          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;

              barData.forEach((data) => {
                data.dataPoints.forEach((point) => {
                  point.label = new Date(point.label + "Z").toLocaleString(
                    "en-IN",
                    {
                      timeZone: "Asia/Kolkata",
                    }
                  );
                });
              });

              this.velLineData.push(barData);
            }

            if (response.rangeLabels.length != 0) {
              this.velColors.push(response.rangeLabels);
            }

            if (this.velColors.length >= 1 || this.velLineData.length >= 1) {
              setTimeout(() => {
                this.velLoading = false;
              }, 1000);
            }
          }

          if (response.movingAvg != undefined) {
            if (response.movingAvg.length != 0) {
              this.velLineMovingAvg = response.movingAvg;
              this.velMovingCount = response.movingCount;
            }
          }
        }
      })
      .finally(() => {
        this.velLoading = false;
      });
  }
  public getAudibleData() {
    this.audibleLoading = true;
    //Enerty Meter:: Line Graph :: Current.
    this.service
      .getDataWithQuery(
        `${this.cylinderBaseUrl}/cylinder/trends/trends-audible/${this.client_id}/${this.asset_id}/${this.device_id}/${this.trendsFilter}/36/${this.subsystem_id}`
        // `http://localhost:7778/cylinder/trends/trends-audible/${this.client_id}/${this.asset_id}/${this.device_id}/hour/36/${this.subsystem_id}`
      )
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.audibleLineData = [];
          this.audibleColors = [];

          this.audibleLineChartOptions = response.name;
          this.audibleLineUnit = response.symbol;

          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;

              barData.forEach((data) => {
                data.dataPoints.forEach((point) => {
                  point.label = new Date(point.label + "Z").toLocaleString(
                    "en-IN",
                    {
                      timeZone: "Asia/Kolkata",
                    }
                  );
                });
              });

              this.audibleLineData.push(barData);
            }

            if (response.rangeLabels.length != 0) {
              this.audibleColors.push(response.rangeLabels);
            }

            if (
              this.audibleColors.length >= 1 ||
              this.audibleLineData.length >= 1
            ) {
              setTimeout(() => {
                this.audibleLoading = false;
              }, 1000);
            }
          }

          if (response.movingAvg != undefined) {
            if (response.movingAvg.length != 0) {
              this.audibleLineMovingAvg = response.movingAvg;
              this.audibleMovingCount = response.movingCount;
            }
          }
        }
      })
      .finally(() => {
        this.audibleLoading = false;
      });
  }
  public getFlowData() {
    this.flowLoading = true;
    //Enerty Meter:: Line Graph :: Current.
    this.service
      .getDataWithQuery(
        `${this.cylinderBaseUrl}/cylinder/trends/trends-flow/${this.client_id}/${this.asset_id}/${this.device_id}/${this.trendsFilter}/36/${this.subsystem_id}`
        // `http://localhost:7778/cylinder/trends/trends-flow/${this.client_id}/${this.asset_id}/${this.device_id}/hour/36/${this.subsystem_id}`
      )
      .then((sRes) => {
        console.log("RESPONSE RECIEVED IS::" + sRes);
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.flowLineData = [];
          this.flowColors = [];

          this.flowLineChartOptions = response.name;
          this.flowLineUnit = response.symbol;

          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;
              this.flowLineData.push(barData);
            }

            if (response.rangeLabels.length != 0) {
              this.flowColors.push(response.rangeLabels);
            }

            if (this.flowColors.length >= 1 || this.flowLineData.length >= 1) {
              setTimeout(() => {
                this.flowLoading = false;
              }, 1000);
            }
          }

          if (response.movingAvg != undefined) {
            if (response.movingAvg.length != 0) {
              this.flowLineMovingAvg = response.movingAvg;
              this.flowMovingCount = response.movingCount;
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
        this.flowLineData = [];
        this.flowColors = [];
      })
      .finally(() => {
        this.flowLoading = false;
      });
  }
  public getPressureData() {
    this.pressureLoading = true;
    //Enerty Meter:: Line Graph :: Current.
    this.service
      .getDataWithQuery(
        `${this.cylinderBaseUrl}/cylinder/trends/trends-pressure/${this.client_id}/${this.asset_id}/${this.device_id}/${this.trendsFilter}/36/${this.subsystem_id}`
        // `http://localhost:7778/cylinder/trends/trends-pressure/${this.client_id}/${this.asset_id}/${this.device_id}/hour/36/${this.subsystem_id}`
      )
      .then((sRes) => {
        let sensorRes = JSON.parse(JSON.stringify(sRes)).data;

        if (sensorRes.body && Object.keys(sensorRes.body).length !== 0) {
          let response = sensorRes.body;
          this.pressureLineData = [];
          this.pressureColors = [];

          this.pressureLineChartOptions = response.name;
          this.pressureLineUnit = response.symbol;

          if (response.sensor != undefined) {
            if (response.sensor.length != 0) {
              let barData = response.sensor;
              this.pressureLineData.push(barData);
            }

            if (response.rangeLabels.length != 0) {
              this.pressureColors.push(response.rangeLabels);
            }

            if (
              this.flowColors.length >= 1 ||
              this.pressureLineData.length >= 1
            ) {
              setTimeout(() => {
                this.pressureLoading = false;
              }, 1000);
            }
          }

          if (response.movingAvg != undefined) {
            if (response.movingAvg.length != 0) {
              this.pressureLineMovingAvg = response.movingAvg;
              this.pressureMovingCount = response.movingCount;
            }
          }
        }
      })
      .catch((err) => {
        this.pressureLineData = [];
        this.pressureColors = [];
      })
      .finally(() => {
        this.pressureLoading = false;
      });
  }

  stackchartvelocity() {
    this.stackData = [];
    let interval = 30;
    let bearingSelectedValue = "";
    this.service
      .getData(
        this.assetsUrlEdit + "/" + this.asset_id + "/" + this.mac_address
      )
      .then((result) => {
        if (JSON.parse(JSON.stringify(result)).data.status === "success") {
          //If "Sleeve Bearing" is selected then "Diagnostics->Bearing Analysist" tab is disabled.
          //Start Code.
          bearingSelectedValue =
            JSON.parse(JSON.stringify(result)).data.body.de_bearing_number ===
            "NA"
              ? "off"
              : "on";
          //End Code.
          if (this.assetType === "GEAR") {
            if (
              JSON.parse(JSON.stringify(result)).data.body.gear_info[0]
                .gear_deb !== "NA" &&
              JSON.parse(JSON.stringify(result)).data.body.gear_info[0]
                .gear_deb !== null &&
              JSON.parse(JSON.stringify(result)).data.body.gear_info[1]
                .gear_deb !== "NA" &&
              JSON.parse(JSON.stringify(result)).data.body.gear_info[1]
                .gear_deb !== null
            ) {
              this.ballBearingOn = false;
            }
          } else if (
            this.assetType != "GEAR" &&
            JSON.parse(JSON.stringify(result)).data.body.de_bearing_number !==
              "NA" &&
            JSON.parse(JSON.stringify(result)).data.body.de_bearing_number !==
              null
          ) {
            this.ballBearingOn = false;
          }
          if (
            JSON.parse(JSON.stringify(result)).data.body.data_frequency > 15
          ) {
            interval = 45;
          } else {
            interval = 30;
          }
        } else {
          interval = 30;
        }

        this.service
          .getDataWithQuery(
            `${this.bucketsensordata}/${this.client_id}/${this.asset_id}/${this.mac_address}/${interval}/29,30,31?lastHours=${this.lastHours[1]}`
          )
          .then((res) => {
            if (JSON.parse(JSON.stringify(res)).data.status == "success") {
              let resdata = JSON.parse(JSON.stringify(res)).data.body;
              // delete resdata[0];
              // console.log(resdata);

              for (let i = 1; i < resdata.length - 1; i++) {
                let testDateUtc = moment.utc(resdata[i].bucket_date).toDate();
                let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
                  testDateUtc
                );
                // console.log(resdata[i].bucket_date +  "=>" + testDateUtc + "=>" + timeUpdatedAt);
                let dateandtime = timeUpdatedAt.split(" ");
                let date = dateandtime[0].toString();
                let time = dateandtime[1].toString();
                let velocityStatus = resdata[i].status.velocity || "N/A";
                let temperatureStatus = resdata[i].status.temperature || "N/A";
                let ultrasoundStatus = resdata[i].status.ultrasound || "N/A";
                // console.log(resdata[i].highest_val ,this.velocityG,resdata[i].highest_val < this.velocityG)
                // if (
                //   resdata[i].highest_val < this.velocityG &&
                //   resdata[i].highest_val > 0
                // ) {
                //   // console.log("INSIDE IF")
                //   this.stackData.push({
                //     type: "stackedBar",
                //     xValueFormatString: time,

                //     color: "#72FF13",
                //     dataPoints: [{ x: 0, y: 30 }],
                //   });
                // } else if (
                //   resdata[i].highest_val > this.velocityG &&
                //   resdata[i].highest_val < this.velocityY
                // ) {
                //   this.stackData.push({
                //     type: "stackedBar",
                //     indexLabelFontColor: "red",
                //     xValueFormatString: time,

                //     color: "#FAA700",
                //     dataPoints: [{ x: 0, y: 30 }],
                //   });
                // } else if (resdata[i].highest_val > this.velocityY) {
                //   this.stackData.push({
                //     type: "stackedBar",
                //     xValueFormatString: time,

                //     color: "#ff2a1b",
                //     dataPoints: [{ x: 0, y: 30 }],
                //   });
                // } else if (resdata[i].highest_val == 0) {
                //   this.stackData.push({
                //     type: "stackedBar",
                //     xValueFormatString: time,

                //     color: "#999999",
                //     dataPoints: [{ x: 0, y: 30 }],
                //   });
                // }
                switch (resdata[i].status.overall) {
                  case "HEALTHY":
                    this.stackData.push({
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#72FF13",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          ultrasoundStatus: ultrasoundStatus,
                        },
                      ],
                    });
                    break;
                  case "WARNING":
                    this.stackData.push({
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#FAA700",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          ultrasoundStatus: ultrasoundStatus,
                        },
                      ],
                    });
                    break;
                  case "CRITICAL":
                    this.stackData.push({
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#ff2a1b",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          ultrasoundStatus: ultrasoundStatus,
                        },
                      ],
                    });
                    break;
                  default:
                    this.stackData.push({
                      type: "stackedBar",
                      xValueFormatString: time,
                      color: "#999999",
                      dataPoints: [
                        {
                          x: 0,
                          y: 30,
                          time: time,
                          velocityStatus: velocityStatus,
                          temperatureStatus: temperatureStatus,
                          ultrasoundStatus: ultrasoundStatus,
                        },
                      ],
                    });
                    break;
                }
              }
              // console.log("Stack data")
              // console.log(this.stackData)
              // console.log(this.stackData.length)
              const chart11 = new CanvasJS.Chart(
                "sdchartContainer",
                {
                  axisX: {
                    valueFormatString: " ",
                    titleFontSize: 100,
                    gridThickness: 0,
                    lineThickness: 0,
                    tickThickness: 0,
                  },
                  axisY: {
                    titleFontSize: 135,
                    valueFormatString: " ",
                    gridThickness: 0,
                    lineThickness: 0,
                    tickThickness: 0,
                  },
                  toolTip: {
                    contentFormatter: function (e) {
                      const dataPoint = e.entries[0].dataPoint;

                      // Helper function to get status color
                      function getStatusColor(status) {
                        switch (status) {
                          case "HEALTHY":
                            return "#72FF13"; // Green
                          case "WARNING":
                            return "#FAA700"; // Orange/Amber
                          case "CRITICAL":
                            return "#ff2a1b"; // Red
                          default:
                            return "#999999"; // Gray for unknown/undefined
                        }
                      }

                      // Color formatting for each status
                      const velocityColor = getStatusColor(
                        dataPoint.velocityStatus
                      );
                      const temperatureColor = getStatusColor(
                        dataPoint.temperatureStatus
                      );
                      const ultrasoundColor = getStatusColor(
                        dataPoint.ultrasoundStatus
                      );

                      return `<div style="padding: 5px;">
                        <b>Time:</b> ${dataPoint.time}<br/>
                        <b>Velocity:</b> <span style="color:${velocityColor}; font-weight:bold">${dataPoint.velocityStatus}</span><br/>
                        <b>Temperature:</b> <span style="color:${temperatureColor}; font-weight:bold">${dataPoint.temperatureStatus}</span><br/>
                        <b>Ultrasound:</b> <span style="color:${ultrasoundColor}; font-weight:bold">${dataPoint.ultrasoundStatus}</span>
                      </div>`;
                    },
                    shared: false,
                  },
                  dataPointWidth: 65,

                  data: this.stackData,
                  afterRender: function () {
                    this.stackvelocitychartLoader = false;
                  },
                }
              );
              chart11.render();
              this.stackvelocitychartLoader = false;
            } else {
            }
          });
      });
  }

  async getalertsummmary() {
    this.currentdate = new Date();
    let currentdate = this.currentdate.toISOString();
    this.currentdate.setDate(this.currentdate.getDate() - 30);
    let old_date = this.currentdate.toISOString();
    let url = "";

    this.clientid = localStorage.getItem("user_id");
    this.role = localStorage.getItem("role");

    // if (this.role == "ADMIN") {
    //   url = `${this.ErrorLogService}/${old_date}/${currentdate}`;
    // } else {
    //   url =
    //     `${this.ErrorLogService}/${old_date}/${currentdate}` +
    //     "?clientid=" +
    //     this.clientid;
    // }
    // await this.service.loadnewData(url).then(async (response) => {
    //   let res = JSON.parse(JSON.stringify(response)).data.body;
    //   let data = JSON.parse(res);

    //   if (JSON.parse(JSON.stringify(response)).data.body == "[]") {
    //     this.showEmptyError = "No Reports Available for week!";
    //     this.checker = true;
    //   } else {
    //     this.checker = false;
    //     this.showEmptyError = "";
    //     this.reportDataArr = data;
    //   }
    // });
    let endpoint = this.alert24hrurl + "alert/errors/";
    this.errordata = [];
    await this.service
      .loadPannelData(
        `${endpoint}${this.client_id}/${this.device_id}/${this.asset_id}/${this.mac_address}/12`
      )
      .then((response) => {
        let res = JSON.parse(JSON.stringify(response)).data.body.errors;

        if (res.length === 0) {
          this.noalertmessage = "No Alerts in last 24 hours";
        } else {
          this.errordata = res;
          for (let i = 0; i < this.errordata.length; i++) {
            let testDateUtc = moment.utc(this.errordata[i].time);

            let localDate = testDateUtc.local();
            let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
              `${this.errordata[i].time}`
            );
            this.errordata[i].time = timeUpdatedAt;
            if (this.errordata[i].ack_time != "") {
              let ackDateUtc = moment.utc(this.errordata[i].ask_time);
              let localDate = ackDateUtc.local();
              let timeAckUpdate = new ConvertDatetimePipe().convertDateTime(
                ` ${this.errordata[i].ack_time}`
              );
              this.errordata[i].ack_time = timeAckUpdate;
            }
          }
          this.noalertmessage = "";
        }
      });
  }

  async goToPageLink(name: string) {
    //check this navigation
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "",
        tab1: true,
        tab2: this.tabsObj.tab2,
        tab3: this.tabsObj.tab3,
        tab4: this.tabsObj.tab4,
        tab5: true,
        tab6: this.tabsObj.tab6,
        tab7: this.tabsObj.tab7,
        tabName: "tab-5",
      },
    };
    this.router.navigate([name], navigationExtras);
  }

  viewAsset() {
    const assetInfoObj = this.assetDataObject.data.body[0];
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "1100px",
      maxWidth: "85vw",
      data: {
        type: "sensorNewDialogBox",
        client_asset_id: assetInfoObj.id,
        asset_type: assetInfoObj.asset_type,
        online_status: assetInfoObj.live_status,
        clientId: this.client_id,
        inventory_id: assetInfoObj.inventory_id,
        asset_status: 1,
        asset_obj: assetInfoObj,
        showKurtosis: 1,
        kurt_freq: 5,
        kurt_threshold: 5,
        kurt_anomaly_counter: 5,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.graphToReload.acceleration) {
        this.monitoringGaugeData(true, false, false);
        // this.getMeterAccData();
      }
      if (result.graphToReload.audible == true) {
        this.getAudibleData();
        this.monitoringGaugeData(false, false, true);
      }
      if (result.graphToReload.sound) {
        this.getUltrasoundData();
        this.monitoringGaugeData(false, false, true);
      }
      if (result.graphToReload.temperature) {
        this.monitoringGaugeData(false, true, false);
        this.getTempData();
      }
      if (result.isChanged) {
      }
      if (result.graphToReload.kwrating3) {
        this.monitoringGaugeData(true, false, false);
        this.getVelocityData();
      }
      if (result.graphToReload.kwrating1) {
        this.monitoringGaugeData(true, false, false);
        this.getVelocityData();
      }
    });
  }

  async fetchAssetSettingData() {
    this.assetDataObject = await this.service
      .getDataWithQuery(
        `${this.assetsListUrl}/info/detail/v2/${this.client_id}/${this.asset_id}/${this.mac_address}`
      )
      .then((assetFullInfo) => {
        return assetFullInfo;
      });
  }

  openFlowPressModal() {
    this.showFlowPressModal = true;
  }

  closeModal(isNew: boolean) {
    this.showFlowPressModal = false;
    if (isNew) {
      this.getFlowGaugeDataV2();
      this.getFlowData();
      this.getPressureGaugeDataV2();
      this.getPressureData();
    }
  }
  openStackedModalModal() {
    this.showStackedModal = true;
  }

  closeStackedModal() {
    this.showStackedModal = false;
  }

  getAssetStatus(lastReceivedStr, currentTimeStr) {
    // Both strings are in IST format: 'YYYY-MM-DD HH:mm:ss'
    const IST = "Asia/Kolkata";

    const lastReceived = moment.tz(lastReceivedStr, "YYYY-MM-DD HH:mm:ss", IST);
    const currentTime = moment.tz(currentTimeStr, "YYYY-MM-DD HH:mm:ss", IST);

    const diffInMinutes = currentTime.diff(lastReceived, "minutes");

    return diffInMinutes <= 15 ? true : false;
  }

  handleTrendsFilter(filter: string) {
    if (filter == this.trendsFilter) {
      return;
    }
    this.trendsFilter = filter;
    // this.getMeterAccData();
    this.getTempData();
    this.getUltrasoundData();
    this.getVelocityData();
    this.getAudibleData();
    this.getFlowData();
    this.getPressureData();
  }

  toggleTrends() {
    if (this.showTrendGraphs) this.showTrendGraphs = false;
    else {
      this.showTrendGraphs = true;
      this.getTempData();
      this.getVelocityData();
      this.getAudibleData();
      this.getUltrasoundData();
      this.getFlowData();
      this.getPressureData();
    }
  }
}
